import styled from "styled-components";

export const Header = styled.div`
  height: 6.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e8ecf2;
  padding: 0 4.4rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;

  background-color: #fff;
  width: 100%;
  .logoIcon {
    cursor: pointer;
  }

  & > .rightWrapper {
    display: flex;
  }
`;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  box-sizing: border-box;

  & > .membershipButton {
    width: 11.8rem;
    padding: 0 1.6rem;
    height: 3.6rem;

    .buttonText {
      line-height: 2.4rem;
      margin-top: 0.2rem;
    }
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  gap: 3.2rem;
  height: 100%;
`;

export const Spacer = styled.div<{ width?: string }>`
  width: ${(props) => props.width ?? "1.6rem"};
`;

export const Divider = styled.div`
  height: 2.4rem;
  width: 0.1rem;
  background-color: #e8ecf2;
`;

export const NotificationContainer = styled.div`
  position: relative;
  width: 2.4rem;
  height: 2.4rem;
  cursor: pointer;

  .icon {
    width: 2.4rem;
    height: 2.4rem;
  }

  .countContainer {
    position: absolute;
    top: -0.2rem;
    left: 1.3rem;
    border-radius: 0.9rem;
    padding: 0.2rem;
    box-sizing: border-box;
    height: 1.6rem;
    background-color: #f72a5c;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1.6rem;

    & > .count {
      color: #fff;
      font-size: 1.1rem;
      font-weight: 600;
      margin-top: 0.1rem;
    }
  }
`;

export const PageButton = styled.div`
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #757c86;
`;

export const MenuItem = styled(PageButton)<{ $isSelected: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  border-bottom: ${({ $isSelected }) => $isSelected && "0.3rem solid #053692"};
  box-sizing: border-box;
  color: ${({ $isSelected }) => $isSelected && "#053692"};
  padding: 1rem;
  box-sizing: border-box;
`;
